<template>
  <div>
    <Movementmenu_govem />
    <v-container fluid>
      <!-- Statistics Cards -->
      <v-row class="mb-4">
        <v-col cols="12" md="3" v-for="stat in statistics" :key="stat.title">
          <v-card
            :color="stat.color"
            dark
            class="text-center pa-4"
            elevation="4"
          >
            <v-icon size="40" class="mb-2">{{ stat.icon }}</v-icon>
            <h2 class="display-1 font-weight-bold">{{ stat.value }}</h2>
            <p class="subtitle-1 mb-0">{{ stat.title }}</p>
          </v-card>
        </v-col>
      </v-row>

      <!-- Charts Row -->
      <v-row class="mb-4">
        <v-col cols="12" md="6">
          <v-card elevation="4">
            <v-card-title>
              <v-icon class="mr-2">mdi-chart-pie</v-icon>
              สถิติสถานะการรายงาน
            </v-card-title>
            <v-card-text>
              <apexchart
                type="pie"
                :options="statusChartOptions"
                :series="statusChartSeries"
                height="300"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card elevation="4">
            <v-card-title>
              <v-icon class="mr-2">mdi-chart-donut</v-icon>
              สถิติความประสงค์
            </v-card-title>
            <v-card-text>
              <apexchart
                type="donut"
                :options="noteChartOptions"
                :series="noteChartSeries"
                height="300"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Main Data Table -->
      <base-material-card
        icon="mdi-clipboard-text"
        title="ข้อมูลสถานศึกษารายงาน สาขาวิชาสำหรับตำแหน่งว่าง"
        class="px-5 py-3"
        elevation="4"
      >
        <!-- Action Buttons -->
        <v-row no-gutters class="mb-3">
          <v-col cols="12" md="8">
            <div class="d-flex align-center flex-wrap">
              <v-chip color="success" dark class="mr-2 mb-2" large>
                <v-icon left>mdi-check-circle</v-icon>
                เสร็จสิ้น: {{ collegeReport.countcf }}
              </v-chip>
              <v-chip color="error" dark class="mr-2 mb-2" large>
                <v-icon left>mdi-alert</v-icon>
                ผิดพลาด: {{ collegeReport.countcc }}
              </v-chip>
              <v-chip color="warning" dark class="mr-2 mb-2" large>
                <v-icon left>mdi-progress-tag</v-icon>
                รอดำเนินการ: {{ collegeReport.countpc }}
              </v-chip>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="d-flex justify-end align-center flex-wrap">
              <v-btn
                color="warning"
                rounded
                outlined
                class="mr-2 mb-2"
                @click="clearCc()"
                :loading="loadingClear"
              >
                <v-icon left>mdi-broom</v-icon>
                ล้างรายการผิดพลาด
              </v-btn>
              <v-btn
                :href="`#/admin/print_jor18_govemReport/`"
                target="_blank"
                color="primary"
                rounded
                class="mb-2"
              >
                <v-icon left>mdi-printer</v-icon>
                พิมพ์รายงาน
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <!-- Filters and Search -->
     <v-row class="mb-3">
  <v-col cols="12" md="4">
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
      single-line
      hide-details
      dense
      filled
      clearable
    />
  </v-col>
  <v-col cols="12" md="2">
    <v-autocomplete
      v-model="regionFilter"
      :items="regionOptions"
      item-text="text"
      item-value="value"
      label="กรองตามภาค"
      clearable
      dense
      filled
    />
  </v-col>
  <v-col cols="12" md="2">
    <v-autocomplete
      v-model="provinceFilter"
      :items="provinceOptions"
      item-text="text"
      item-value="value"
      label="กรองตามจังหวัด"
      clearable
      dense
      filled
    />
  </v-col>
  <v-col cols="12" md="2">
    <v-select
      v-model="statusFilter"
      :items="statusFilterItems"
      label="กรองตามสถานะ"
      clearable
      dense
      filled
    />
  </v-col>
  <v-col cols="12" md="2">
    <v-select
      v-model="noteFilter"
      :items="college_manpower_note"
      label="กรองตามความประสงค์"
      clearable
      dense
      filled
    />
  </v-col>
</v-row>

        <!-- Column Selection -->
        <v-row class="mb-3">
          <v-col cols="12">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="เลือกคอลัมน์ที่ต้องการแสดง"
              multiple
              outlined
              dense
              return-object
              chips
              small-chips
              deletable-chips
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 4"
                  small
                  close
                  @click:close="removeHeader(item)"
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 4" class="grey--text caption">
                  (+{{ selectedHeaders.length - 4 }} คอลัมน์)
                </span>
              </template>
            </v-select>
          </v-col>
        </v-row>

        <!-- Data Table -->
        <v-data-table
          :headers="showHeaders"
          :items="filteredItems"
          :search="search"
          :loading="loading"
          class="elevation-1"
          :items-per-page="15"
          :footer-props="{
            'items-per-page-options': [10, 15, 25, 50, 100]
          }"
        >
          <template v-slot:loading>
            <div class="text-center pa-4">
              <v-progress-circular indeterminate color="primary" size="40" />
              <p class="mt-2">กำลังโหลดข้อมูล...</p>
            </div>
          </template>

                

          <!-- Branch Name -->
          <template v-slot:item.name_branch="{ item }">
            <div>
              <v-chip
                small
                :color="item.name_branch ? 'success' : 'warning'"
                dark
              >
                {{ item.name_branch || item.college_manpower_idbranch }}
              </v-chip>
            </div>
          </template>

          <!-- Status -->
          <template v-slot:item.college_manpower_status="{ item }">
            <div class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="item.college_manpower_status === 'cc'"
                    v-bind="attrs"
                    v-on="on"
                    small
                    fab
                    color="error"
                    @click="cancelAlert(item.college_manpower_ref)"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                  <v-icon
                    v-else-if="item.college_manpower_status === 'cf'"
                    v-bind="attrs"
                    v-on="on"
                    color="success"
                    size="35"
                  >
                    mdi-check-circle
                  </v-icon>
                  <v-icon
                    v-else
                    v-bind="attrs"
                    v-on="on"
                    size="35"
                    color="warning"
                  >
                    mdi-progress-tag
                  </v-icon>
                </template>
                <span>{{ getStatusText(item.college_manpower_status) }}</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Note with Color Coding -->
          <template v-slot:item.college_manpower_note="{ item }">
            <v-chip
              small
              :color="getNoteColor(item.college_manpower_note)"
              dark
            >
              {{ item.college_manpower_note }}
            </v-chip>
          </template>

          <!-- Timestamp -->
          <template v-slot:item.college_manpower_timestamp="{ item }">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ formatDate(item.college_manpower_timestamp) }}
                  </span>
                </template>
                <span>{{
                  formatDateTime(item.college_manpower_timestamp)
                }}</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Actions -->
          <template v-slot:item.del_action="{ item }">
            <div class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="delReport(item.college_manpower_ref)"
                    color="error"
                    small
                    fab
                    :loading="loadingDelete === item.college_manpower_ref"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>ลบรายการ</span>
              </v-tooltip>
            </div>
          </template>

          <!-- No Results -->
          <template v-slot:no-results>
            <div class="text-center pa-4">
              <v-icon size="60" color="grey">mdi-database-search</v-icon>
              <p class="mt-2 grey--text">
                ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา
              </p>
            </div>
          </template>

          <!-- No Data -->
          <template v-slot:no-data>
            <div class="text-center pa-4">
              <v-icon size="60" color="grey">mdi-database-off</v-icon>
              <p class="mt-2 grey--text">ไม่มีข้อมูล</p>
            </div>
          </template>
        </v-data-table>
      </base-material-card>
    </v-container>
  </div>
</template>

<script>
import Movementmenu_govem from "../../components/admin/movementmenu_govem.vue";

export default {
  name: "CollegeManpowerReport",
  components: { Movementmenu_govem },

  data() {
    return {
      loading: true,
      loadingClear: false,
      loadingDelete: null,
      ApiKey: "HRvec2021",
      search: "",
      statusFilter: null,
      noteFilter: null,

      headers: [],
      selectedHeaders: [],

      headersMap: [
        { text: "ID_Ref", align: "left", value: "college_manpower_ref" },
        {
          text: "สถานศึกษา",
          align: "left",
          value: "college_manpower_idcollege"
        },
        { text: "ภาค", align: "left", value: "region_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "ผู้รายงาน", align: "left", value: "user_firstname" },
        { text: "ตำแหน่ง", align: "center", value: "name_postion" },
        {
          text: "ความประสงค์",
          align: "center",
          value: "college_manpower_note"
        },
        {
          text: "รายละเอียดเพิ่มเติม",
          align: "center",
          value: "college_manpower_note_sub"
        },
        {
          text: "เลขที่ตำแหน่ง",
          align: "center",
          value: "college_manpower_idposition"
        },
        { text: "ตำแหน่ง/สาขาวิชา", align: "left", value: "name_branch" },
        { text: "เหตุผล", align: "left", value: "college_manpower_comment" },
        { text: "สถานะ", align: "center", value: "college_manpower_status" },   
      ],

      college_manpowers: [],
      collegeReport: {
        countcc: 0,
        countcf: 0,
        countpc: 0
      },
      period_colleges: {},

      college_manpower_note: [
        { text: "สรรหา", value: "สรรหา" },
        { text: "เรียกใช้บัญชี", value: "เรียกใช้บัญชี" },
        { text: "รับย้าย", value: "รับย้าย" }
      ],

      statusFilterItems: [
        { text: "เสร็จสิ้น", value: "cf" },
        { text: "ผิดพลาด", value: "cc" },
        { text: "รอดำเนินการ", value: "pc" }
      ],

      // Chart Options
      statusChartOptions: {
        chart: {
          type: "pie",
          fontFamily: "Roboto, sans-serif"
        },
        labels: ["เสร็จสิ้น", "ผิดพลาด", "รอดำเนินการ"],
        colors: ["#4CAF50", "#F44336", "#FF9800"],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },

      noteChartOptions: {
        chart: {
          type: "donut",
          fontFamily: "Roboto, sans-serif"
        },
        labels: ["สรรหา", "เรียกใช้บัญชี", "รับย้าย"],
        colors: ["#2196F3", "#9C27B0", "#00BCD4"],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },

      timelineChartOptions: {
        chart: {
          type: "line",
          fontFamily: "Roboto, sans-serif",
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค."
          ]
        },
        yaxis: {
          title: {
            text: "จำนวนรายงาน"
          }
        },
        stroke: {
          curve: "smooth",
          width: 3
        },
        colors: ["#4CAF50", "#F44336", "#FF9800"],
        legend: {
          position: "top"
        }
      },

      regionFilter: null,
      provinceFilter: null,
      regionOptions: [],
      provinceOptions: []
    };
  },

  computed: {
    showHeaders() {
      return this.headers.filter(h => this.selectedHeaders.includes(h));
    },

   filteredItems() {
  let filtered = this.college_manpowers;

  if (this.statusFilter) {
    filtered = filtered.filter(item => item.college_manpower_status === this.statusFilter);
  }
  if (this.noteFilter) {
    filtered = filtered.filter(item => item.college_manpower_note === this.noteFilter);
  }
  if (this.regionFilter) {
    filtered = filtered.filter(item => item.region_name === this.regionFilter);
  }
  if (this.provinceFilter) {
    filtered = filtered.filter(item => item.province_name === this.provinceFilter);
  }

  return filtered;
},

    statistics() {
      return [
        {
          title: "เสร็จสิ้น",
          value: this.collegeReport.countcf,
          color: "success",
          icon: "mdi-check-circle"
        },
        {
          title: "ผิดพลาด",
          value: this.collegeReport.countcc,
          color: "error",
          icon: "mdi-alert"
        },
        {
          title: "รอดำเนินการ",
          value: this.collegeReport.countpc,
          color: "warning",
          icon: "mdi-progress-tag"
        },
        {
          title: "ทั้งหมด",
          value:
            this.collegeReport.countcf +
            this.collegeReport.countcc +
            this.collegeReport.countpc,
          color: "primary",
          icon: "mdi-format-list-numbered"
        }
      ];
    },

    statusChartSeries() {
      return [
        this.collegeReport.countcf,
        this.collegeReport.countcc,
        this.collegeReport.countpc
      ];
    },

    noteChartSeries() {
      const noteCounts = this.college_manpower_note.map(note => {
        return this.college_manpowers.filter(
          item => item.college_manpower_note === note.value
        ).length;
      });
      return noteCounts;
    }
  },

  async created() {
    this.headers = [...this.headersMap];
    this.selectedHeaders = [...this.headers];
  },

  async mounted() {
    await this.periodQuery();
    await this.college_manpowerQueryAll();
    // สร้าง options จากข้อมูลที่โหลดมา
    this.regionOptions = [
      ...new Set(this.college_manpowers.map(item => item.region_name))
    ].map(region => ({ text: region, value: region }));
    this.provinceOptions = [
      ...new Set(this.college_manpowers.map(item => item.province_name))
    ].map(province => ({ text: province, value: province }));
  },

  methods: {
    async clearCc() {
      this.loadingClear = true;

      try {
        const result = await this.$http.post(
          "college_manpower.updateclearcc.php",
          {
            ApiKey: this.ApiKey
          }
        );

        if (result.data.status) {
          Swal.fire({
            title: "ดำเนินการข้อมูลเรียบร้อย",
            icon: "success",
            showConfirmButton: false,
            timer: 1500
          });
          await this.college_manpowerQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ไม่พบรายการที่ต้องปรับปรุง",
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: error.message,
          showConfirmButton: false,
          timer: 1500
        });
      } finally {
        this.loadingClear = false;
      }
    },

    async delReport(college_manpower_ref) {
      const result = await Swal.fire({
        title: "ลบรายการ",
        text: "ลบเพื่อดำเนินการสร้างใหม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });

      if (result.isConfirmed) {
        this.loadingDelete = college_manpower_ref;

        try {
          const reportResult = await this.$http.post(
            "college_manpower_govem.php",
            {
              ApiKey: this.ApiKey,
              college_manpower_ref: college_manpower_ref
            }
          );

          const college_manpowerCC = reportResult.data;
          college_manpowerCC.ApiKey = this.ApiKey;

          // Delete file
          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename: `../HRvecfiles/${college_manpowerCC.college_manpowerfile}`
          });

          // Delete record
          await this.$http.post(
            "college_manpower.delete.php",
            college_manpowerCC
          );

          // Delete reference
          await this.$http.post("college_manpower.deleteidref.php", {
            ApiKey: this.ApiKey,
            college_manpower_ref: college_manpower_ref
          });

          Swal.fire({
            title: "ดำเนินการข้อมูลเรียบร้อย",
            icon: "success",
            showConfirmButton: false,
            timer: 1500
          });

          await this.college_manpowerQueryAll();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: error.message
          });
        } finally {
          this.loadingDelete = null;
        }
      }
    },

    async cancelAlert(college_manpower_ref) {
      const result = await Swal.fire({
        title: "ขอยกเลิกการแนบไฟล์",
        text: "เนื่องจากแนบไฟล์ผิดพลาด",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });

      if (result.isConfirmed) {
        try {
          const reportResult = await this.$http.post(
            "college_manpower_govem.php",
            {
              ApiKey: this.ApiKey,
              college_manpower_ref: college_manpower_ref
            }
          );

          const college_manpowerCC = reportResult.data;
          college_manpowerCC.ApiKey = this.ApiKey;

          // Delete file
          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename: `../HRvecfiles/${college_manpowerCC.college_manpowerfile}`
          });

          // Update record
          college_manpowerCC.college_manpowerfile = "-";
          college_manpowerCC.college_manpower_status = "-";

          await this.$http.post(
            "college_manpower.update.php",
            college_manpowerCC
          );

          Swal.fire({
            title: "ดำเนินการข้อมูลเรียบร้อย",
            icon: "success",
            showConfirmButton: false,
            timer: 1500
          });

          await this.college_manpowerQueryAll();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: error.message
          });
        }
      }
    },

    async periodQuery() {
      try {
        const result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: "801"
        });
        this.period_colleges = result.data;
      } catch (error) {
        console.error("Error fetching period data:", error);
      }
    },

    async college_manpowerQueryAll() {
      this.loading = true;

      try {
        const result = await this.$http.post("college_manpower_govem.php", {
          ApiKey: this.ApiKey,
          college_manpower_time: this.period_colleges.period_college_times,
          college_manpower_year: this.period_colleges.period_college_year
        });

        this.college_manpowers = result.data;
        this.calculateStatistics();
      } catch (error) {
        console.error("Error fetching college manpower data:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถโหลดข้อมูลได้"
        });
      } finally {
        this.loading = false;
      }
    },

    calculateStatistics() {
      const data = this.college_manpowers;
      let countcc = 0;
      let countcf = 0;
      let countpc = 0;

      data.forEach(item => {
        switch (item.college_manpower_status) {
          case "cc":
            countcc++;
            break;
          case "cf":
            countcf++;
            break;
          default:
            countpc++;
            break;
        }
      });

      this.collegeReport = { countcc, countcf, countpc };
    },

    removeHeader(header) {
      this.selectedHeaders = this.selectedHeaders.filter(h => h !== header);
    },

    getStatusText(status) {
      switch (status) {
        case "cf":
          return "เสร็จสิ้น";
        case "cc":
          return "ผิดพลาด";
        default:
          return "รอดำเนินการ";
      }
    },

    getNoteColor(note) {
      switch (note) {
        case "สรรหา":
          return "primary";
        case "เรียกใช้บัญชี":
          return "purple";
        case "รับย้าย":
          return "teal";
        default:
          return "grey";
      }
    },

    formatDate(timestamp) {
      if (!timestamp) return "-";
      return this.$moment(timestamp)
        .add(543, "year")
        .format("DD/MM/YYYY");
    },

    formatDateTime(timestamp) {
      if (!timestamp) return "-";
      return this.$moment(timestamp)
        .add(543, "year")
        .format("DD/MM/YYYY HH:mm:ss");
    }
  }
};
</script>

<style scoped>
.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.statistics-card {
  background: linear-gradient(
    135deg,
    var(--v-primary-base),
    var(--v-primary-darken1)
  );
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.v-data-table >>> .v-data-table__wrapper {
  border-radius: 8px;
}

.v-chip {
  font-weight: 500;
}

.status-chip {
  min-width: 80px;
  justify-content: center;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .v-card {
    margin-bottom: 1rem;
  }

  .d-flex.flex-wrap {
    justify-content: center;
  }

  .v-chip {
    margin: 2px;
  }
}

/* Loading animation */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* Chart container styling */
.chart-container {
  position: relative;
  height: 300px;
}

/* Enhanced button styling */
.v-btn {
  text-transform: none;
  font-weight: 500;
}

.v-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Status indicators */
.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.status-indicator.success {
  color: #4caf50;
}

.status-indicator.error {
  color: #f44336;
}

.status-indicator.warning {
  color: #ff9800;
}

/* Enhanced table styling */
.v-data-table >>> .v-data-table-header {
  background-color: #f8f9fa;
}

.v-data-table >>> .v-data-table-header th {
  color: #495057 !important;
  font-weight: 600;
}

.v-data-table >>> tbody tr:hover {
  background-color: #f8f9fa !important;
}

/* Custom material card enhancement */
.base-material-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
}

/* Animation for statistics cards */
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.statistics-card:hover {
  animation: pulse 0.6s ease-in-out;
}

/* Loading spinner enhancement */
.v-progress-circular {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Search field enhancement */
.v-text-field >>> .v-input__control {
  border-radius: 8px;
}

.v-text-field >>> .v-input__slot {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.v-text-field >>> .v-input__slot:hover {
  border-color: #1976d2;
}

/* Select field enhancement */
.v-select >>> .v-select__selections {
  flex-wrap: wrap;
}

.v-select >>> .v-chip {
  margin: 2px;
}

/* Tooltip enhancement */
.v-tooltip__content {
  background: rgba(0, 0, 0, 0.9) !important;
  border-radius: 4px;
  font-size: 12px;
}

/* Action buttons enhancement */
.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.action-buttons .v-btn {
  min-width: 40px;
  height: 40px;
}

/* Enhanced chip styling */
.v-chip.v-chip--outlined {
  border-width: 2px;
}

.v-chip.v-size--small {
  font-size: 11px;
  height: 24px;
}

/* Print button enhancement */
.print-button {
  background: linear-gradient(135deg, #1976d2, #1565c0);
  color: white;
  border: none;
}

.print-button:hover {
  background: linear-gradient(135deg, #1565c0, #0d47a1);
}

/* Clear button enhancement */
.clear-button {
  background: linear-gradient(135deg, #ff9800, #f57c00);
  color: white;
  border: none;
}

.clear-button:hover {
  background: linear-gradient(135deg, #f57c00, #e65100);
}

/* Data table pagination enhancement */
.v-data-table >>> .v-data-footer {
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
}

/* Empty state styling */
.empty-state {
  text-align: center;
  padding: 2rem;
  color: #666;
}

.empty-state .v-icon {
  opacity: 0.6;
  margin-bottom: 1rem;
}

/* Responsive chart adjustments */
@media (max-width: 600px) {
  .chart-container {
    height: 250px;
  }

  .v-card-title {
    font-size: 1.1rem;
    padding: 12px 16px;
  }
}
</style>
